import { render, staticRenderFns } from "./deliveryareaSetting_new.vue?vue&type=template&id=7e6f5a31&scoped=true"
import script from "./deliveryareaSetting_new.vue?vue&type=script&lang=js"
export * from "./deliveryareaSetting_new.vue?vue&type=script&lang=js"
import style0 from "./deliveryareaSetting_new.vue?vue&type=style&index=0&id=7e6f5a31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f5a31",
  null
  
)

export default component.exports